import {
    WORKFLOW_SEARCH,
    WORKFLOW_SEARCH_ON_FAIL,
    WORKFLOW_SEARCH_ON_SUCCESS
} from './actions';
import {CREATE_MODE} from 'utils/appConstant'

const initialState = {
    init: true,
    crud_init: false,
    selectData: null,
    params: null,
    workFlowList: null,
    actionMode: null,
    messageType: null,
    lastMessage: null,
}

const getWorkflowList = wrokflowPagination => {
    return wrokflowPagination.content
}

const getErrorMessage = error => {
    return error.message
}


export function workflowManagementReducer(state = initialState, action) {
    let data = action.payload;
  
    switch (action.type) {
        case WORKFLOW_SEARCH:
            return {
                ...state,
                params: data,
                userList: null
            }
        case WORKFLOW_SEARCH_ON_SUCCESS:
            return {
                ...state,
                workFlowList: getWorkflowList(data),
                lastErrorMessage: null
            }
        case WORKFLOW_SEARCH_ON_FAIL:
            return {
                ...state,
                workFlowList: [],
                lastErrorMessage: getErrorMessage(data),
            }
        default:
            //console.log('userManagementReducer Unimplemented', action.type)
            return state;
    }
}